import { TEntityRef } from '@ws/shared/types';

import { TWindowSettings } from '../../redux/contentWindows/contentWindows.types';

/**
 * У этого модуля СОЗНАТЕЛЬНО нет `index.ts`-барреля, в отличие от соседей по `utils/`.
 *
 * Баррель затянул бы `editorLayout.collect` и `editorLayout.subscribe` (а они зависят
 * от `redux/types`) в каждого, кто импортирует хоть один тип отсюда. Для redux-модулей
 * это замыкает цикл: `redux/layout` → баррель → `collect` → `redux/types` →
 * `contentWindows.slice` → `redux/layout`. Проверено — `import/no-cycle` даёт 11 ошибок.
 * Импортируйте нужный файл напрямую.
 */
export const EDITOR_LAYOUT_VERSION = 1;

/**
 * Срез конфигурации экрана редактора, сохраняемый отдельно для каждого проекта.
 *
 * При добавлении нового UI-состояния, которое должно переживать перезагрузку, правки
 * нужны в трёх местах сразу: здесь, в `collectLayout`, и в списке наблюдаемых полей
 * подписки. Забыть любое из трёх — значит получить поле, которое либо не сохраняется,
 * либо сохраняется только случайно, за компанию с другим изменением.
 *
 * Осознанно НЕ входят:
 * - `isSidebarOpen` — предпочтение про экран, а не про проект; остаётся глобальным;
 * - `isPreviewsOpen` — панель тянет данные с сервера, открывать её при старте не надо.
 * - `isTkPanelOpen` — панель локальна и ничего не запрашивает, но открытая при
 *   загрузке боковая панель — сюрприз, которого автор не просил.
 */
export type TEditorLayout = {
  v: typeof EDITOR_LAYOUT_VERSION;
  savedAt: number;

  // Используется ТОЛЬКО для построения URL при входе в проект: единственный писатель
  // в `editor.selected` — роутинг, и restore его не трогает.
  selected: TEntityRef | null;

  secondarySelected: TEntityRef | null;

  isCompiled: boolean;
  isSecondaryCompiled: boolean;

  // TWindowSettings именно redux'овый — тот, что с полем isOpen.
  contentWindows: {
    list: string[];
    settings: Record<string, TWindowSettings>;
  };
};

export type TLayoutIndexEntry = {
  id: string;
  savedAt: number;
};

export const EMPTY_EDITOR_LAYOUT: TEditorLayout = {
  v: EDITOR_LAYOUT_VERSION,
  savedAt: 0,
  selected: null,
  secondarySelected: null,
  isCompiled: false,
  isSecondaryCompiled: true,
  contentWindows: { list: [], settings: {} },
};
